function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", null, "#e0atq4nki7rh5_to {animation: e0atq4nki7rh5_to__to 12000ms linear infinite normal forwards}@keyframes e0atq4nki7rh5_to__to { 0% {transform: translate(44px,32.500000px)} 8.333333% {transform: translate(44px,32.500000px)} 16.666667% {transform: translate(44px,35.500000px)} 25% {transform: translate(44px,32.500000px)} 33.333333% {transform: translate(44px,35.500000px)} 41.666667% {transform: translate(44px,32.500000px)} 50% {transform: translate(44px,35.500000px)} 58.333333% {transform: translate(44px,32.500000px)} 66.666667% {transform: translate(44px,35.500000px)} 75% {transform: translate(44px,32.500000px)} 100% {transform: translate(44px,32.500000px)} }#e0atq4nki7rh5_ts {animation: e0atq4nki7rh5_ts__ts 12000ms linear infinite normal forwards}@keyframes e0atq4nki7rh5_ts__ts { 0% {transform: rotate(180deg) scale(0,0)} 4.166667% {transform: rotate(180deg) scale(1,1)} 79.166667% {transform: rotate(180deg) scale(1,1)} 83.333333% {transform: rotate(180deg) scale(0,0)} 100% {transform: rotate(180deg) scale(0,0)} }#e0atq4nki7rh6 {animation: e0atq4nki7rh6__sz 12000ms linear infinite normal forwards}@keyframes e0atq4nki7rh6__sz { 0% {width: 2px;height: 0px} 4.166667% {width: 2px;height: 5px} 79.166667% {width: 2px;height: 5px} 83.333333% {width: 2px;height: 0px} 100% {width: 2px;height: 0px} }#e0atq4nki7rh7 {animation: e0atq4nki7rh7__sz 12000ms linear infinite normal forwards}@keyframes e0atq4nki7rh7__sz { 0% {width: 2px;height: 0px} 4.166667% {width: 2px;height: 5px} 79.166667% {width: 2px;height: 5px} 83.333333% {width: 2px;height: 0px} 100% {width: 2px;height: 0px} }#e0atq4nki7rh8 {\n           animation-name: e0atq4nki7rh8__sz, e0atq4nki7rh8__rd;\n           animation-duration: 12000ms;\n           animation-fill-mode: forwards;\n           animation-timing-function: linear;\n           animation-direction: normal;\n           animation-iteration-count: infinite;\n        }@keyframes e0atq4nki7rh8__sz { 0% {width: 5px;height: 5px} 4.166667% {width: 16px;height: 2px} 79.166667% {width: 16px;height: 2px} 83.333333% {width: 5px;height: 5px} 100% {width: 5px;height: 5px} }@keyframes e0atq4nki7rh8__rd { 0% {} 4.166667% {} 79.166667% {} 83.333333% {} 100% {} }#e0atq4nki7rh8_to {animation: e0atq4nki7rh8_to__to 12000ms linear infinite normal forwards}@keyframes e0atq4nki7rh8_to__to { 0% {transform: translate(15.500000px,11.500000px)} 4.166667% {transform: translate(10px,14px)} 79.166667% {transform: translate(10px,14px)} 83.333333% {transform: translate(15.500000px,11.500000px)} 100% {transform: translate(15.500000px,11.500000px)} }#e0atq4nki7rh9_to {animation: e0atq4nki7rh9_to__to 12000ms linear infinite normal forwards}@keyframes e0atq4nki7rh9_to__to { 0% {transform: translate(46.500000px,32px)} 4.166667% {transform: translate(44.250000px,33px)} 79.166667% {transform: translate(44.250000px,33px)} 83.333333% {transform: translate(46.500000px,32px)} 100% {transform: translate(46.500000px,32px)} }#e0atq4nki7rh9_ts {animation: e0atq4nki7rh9_ts__ts 12000ms linear infinite normal forwards}@keyframes e0atq4nki7rh9_ts__ts { 0% {transform: scale(1,1)} 4.166667% {transform: scale(0,0)} 79.166667% {transform: scale(0,0)} 83.333333% {transform: scale(1,1)} 100% {transform: scale(1,1)} }#e0atq4nki7rh10_to {animation: e0atq4nki7rh10_to__to 12000ms linear infinite normal forwards}@keyframes e0atq4nki7rh10_to__to { 0% {transform: translate(15.500000px,-4.500000px)} 4.166667% {transform: translate(44px,23.500000px)} 79.166667% {transform: translate(44px,23.500000px)} 83.333333% {transform: translate(15.500000px,-4.500000px)} 100% {transform: translate(15.500000px,-4.500000px)} }#e0atq4nki7rh10_ts {animation: e0atq4nki7rh10_ts__ts 12000ms linear infinite normal forwards}@keyframes e0atq4nki7rh10_ts__ts { 0% {transform: scale(1,1)} 4.166667% {transform: scale(0,0)} 79.166667% {transform: scale(0,0)} 83.333333% {transform: scale(1,1)} 100% {transform: scale(1,1)} }#e0atq4nki7rh11_to {animation: e0atq4nki7rh11_to__to 12000ms linear infinite normal forwards}@keyframes e0atq4nki7rh11_to__to { 0% {transform: translate(9px,1px)} 4.166667% {transform: translate(-20.500000px,-26px)} 8.333333% {transform: translate(-20.500000px,-26px)} 16.666667% {transform: translate(-20.500000px,-23px)} 25% {transform: translate(-20.500000px,-26px)} 33.333333% {transform: translate(-20.500000px,-23px)} 41.666667% {transform: translate(-20.500000px,-26px)} 50% {transform: translate(-20.500000px,-23px)} 58.333333% {transform: translate(-20.500000px,-26px)} 66.666667% {transform: translate(-20.500000px,-23px)} 75% {transform: translate(-20.500000px,-26px)} 79.166667% {transform: translate(-20.500000px,-26px)} 83.333333% {transform: translate(9px,1px)} 100% {transform: translate(9px,1px)} }#e0atq4nki7rh11_ts {animation: e0atq4nki7rh11_ts__ts 12000ms linear infinite normal forwards}@keyframes e0atq4nki7rh11_ts__ts { 0% {transform: scale(0,0)} 4.166667% {transform: scale(1,1)} 79.166667% {transform: scale(1,1)} 83.333333% {transform: scale(0,0)} 100% {transform: scale(0,0)} }");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "e0atq4nki7rh2",
  d: "M11,8.500000C9.620455,8.500000,8.500000,9.618182,8.500000,11C8.500000,12.379546,9.620455,13.500000,11,13.500000C12.381818,13.500000,13.500000,12.379546,13.500000,11C13.500000,9.618182,12.381818,8.500000,11,8.500000ZM3,8.500000C1.620455,8.500000,0.500000,9.618182,0.500000,11C0.500000,12.379546,1.620455,13.500000,3,13.500000C4.381818,13.500000,5.500000,12.379546,5.500000,11C5.500000,9.618182,4.381818,8.500000,3,8.500000ZM-5,8.500000C-6.379545,8.500000,-7.500000,9.618182,-7.500000,11C-7.500000,12.379546,-6.379545,13.500000,-5,13.500000C-3.618182,13.500000,-2.500000,12.379546,-2.500000,11C-2.500000,9.618182,-3.618182,8.500000,-5,8.500000L-5,8.500000Z",
  fill: "rgb(0,0,0)",
  stroke: "none",
  strokeWidth: 1
}), React.createElement("path", {
  id: "e0atq4nki7rh3",
  d: "M11,8.500000C9.620455,8.500000,8.500000,9.618182,8.500000,11C8.500000,12.379546,9.620455,13.500000,11,13.500000C12.381818,13.500000,13.500000,12.379546,13.500000,11C13.500000,9.618182,12.381818,8.500000,11,8.500000ZM3,8.500000C1.620455,8.500000,0.500000,9.618182,0.500000,11C0.500000,12.379546,1.620455,13.500000,3,13.500000C4.381818,13.500000,5.500000,12.379546,5.500000,11C5.500000,9.618182,4.381818,8.500000,3,8.500000ZM-5,8.500000C-6.379545,8.500000,-7.500000,9.618182,-7.500000,11C-7.500000,12.379546,-6.379545,13.500000,-5,13.500000C-3.618182,13.500000,-2.500000,12.379546,-2.500000,11C-2.500000,9.618182,-3.618182,8.500000,-5,8.500000L-5,8.500000Z",
  fill: "rgb(0,0,0)",
  stroke: "none",
  strokeWidth: 1
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "e0atq4nki7rh4",
  transform: "matrix(1 0 0 1 -35 -21)"
}, React.createElement("g", {
  id: "e0atq4nki7rh5_to",
  transform: "translate(44,32.500000)"
}, React.createElement("g", {
  id: "e0atq4nki7rh5_ts",
  transform: "rotate(180) scale(0,0)"
}, React.createElement("polygon", {
  id: "e0atq4nki7rh5",
  points: "24,23.150000 19,28.150000 29,28.150000 24,23.150000",
  transform: "translate(-24,-25.650000)",
  fill: "rgb(196,202,208)",
  stroke: "none",
  strokeWidth: 1
}))), React.createElement("rect", {
  id: "e0atq4nki7rh6",
  width: 2,
  height: 0,
  rx: 0,
  ry: 0,
  transform: "matrix(1 0 0 1 50 37)",
  fill: "rgb(196,202,208)",
  stroke: "none",
  strokeWidth: 1
}), React.createElement("rect", {
  id: "e0atq4nki7rh7",
  width: 2,
  height: 0,
  rx: 0,
  ry: 0,
  transform: "matrix(1 0 0 1 36 37)",
  fill: "rgb(196,202,208)",
  stroke: "none",
  strokeWidth: 1
}), React.createElement("g", {
  id: "e0atq4nki7rh8_to",
  transform: "translate(15.500000,11.500000)"
}, React.createElement("rect", {
  id: "e0atq4nki7rh8",
  width: 5,
  height: 5,
  rx: 2.5,
  ry: 2.5,
  transform: "translate(26,26)",
  fill: "rgb(196,202,208)",
  stroke: "none",
  strokeWidth: 1
})), React.createElement("g", {
  id: "e0atq4nki7rh9_to",
  transform: "translate(46.500000,32)"
}, React.createElement("g", {
  id: "e0atq4nki7rh9_ts",
  transform: "scale(1,1)"
}, React.createElement("rect", {
  id: "e0atq4nki7rh9",
  width: 5,
  height: 5,
  rx: 2.5,
  ry: 2.5,
  transform: "translate(-5,-2.500000)",
  fill: "rgb(196,202,208)",
  stroke: "none",
  strokeWidth: 1
}))), React.createElement("g", {
  id: "e0atq4nki7rh10_to",
  transform: "translate(15.500000,-4.500000)"
}, React.createElement("g", {
  id: "e0atq4nki7rh10_ts",
  transform: "scale(1,1)"
}, React.createElement("rect", {
  id: "e0atq4nki7rh10",
  width: 5,
  height: 5,
  rx: 2.5,
  ry: 2.5,
  transform: "translate(26,26)",
  fill: "rgb(196,202,208)",
  stroke: "none",
  strokeWidth: 1
}))));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "e0atq4nki7rh11_to",
  transform: "translate(9,1)"
}, React.createElement("g", {
  id: "e0atq4nki7rh11_ts",
  transform: "scale(0,0)"
}, React.createElement("rect", {
  id: "e0atq4nki7rh11",
  width: 5,
  height: 9.5,
  rx: 0,
  ry: 0,
  transform: "translate(27,27)",
  fill: "rgb(196,202,208)",
  stroke: "none",
  strokeWidth: 1
})));

var SvgAnimatedDots = function SvgAnimatedDots(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "e0atq4nki7rh1",
    viewBox: "0 0 18 23",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAnimatedDots, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/animated_dots.efcf3361.svg";
export { ForwardRef as ReactComponent };